import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "product-quote-tab position-relative" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.booster.co.nz/mybooster.aspx",
      class: "btn btn-booster-primary"
    }, " Back to mybooster ")
  ])
], -1)
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12 center-btn" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12 text-end center-btn" }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", { class: "hr" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "item-body item-bold" }, "What we can offer you:", -1)
const _hoisted_14 = { class: "row" }
const _hoisted_15 = {
  key: 0,
  class: "mt-1 mb-3 item-validation-error"
}
const _hoisted_16 = {
  key: 0,
  class: "mb-3 item-body px-0"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "row overflow-x-hidden" }
const _hoisted_20 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12 center-btn" }
const _hoisted_21 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12 text-end center-btn" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "col-lg-6 col-md-6 col-sm-6 col-xs-12 center-btn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinnerWithBackground = _resolveComponent("LoadingSpinnerWithBackground")!
  const _component_ResultCannotContinue = _resolveComponent("ResultCannotContinue")!
  const _component_ResultReferred = _resolveComponent("ResultReferred")!
  const _component_ResultSuccess = _resolveComponent("ResultSuccess")!
  const _component_CoverAmountCard = _resolveComponent("CoverAmountCard")!
  const _component_QuoteCard = _resolveComponent("QuoteCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingSpinnerWithBackground, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.isPolicyDeclined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_ResultCannotContinue),
          _hoisted_3,
          _createElementVNode("hr", {
            class: _normalizeClass(["hr medium-bottom-spacing", { 'd-none': _ctx.isMobileScreen }])
          }, null, 2),
          _hoisted_4
        ]))
      : (!_ctx.isLoading && _ctx.isPolicyReferred)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_ResultReferred),
            _hoisted_6,
            _createElementVNode("hr", {
              class: _normalizeClass(["hr medium-bottom-spacing", { 'd-none': _ctx.isMobileScreen }])
            }, null, 2),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("a", {
                  href: _ctx.adviserHubUrl,
                  class: "btn btn-booster-secondary float-start"
                }, " Back home ", 8, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "btn btn-booster-primary float-end",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToNextPage()))
                }, " Continue ")
              ])
            ])
          ]))
        : (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_ResultSuccess, { "with-amendments": _ctx.withAmendments }, null, 8, ["with-amendments"]),
              _hoisted_12,
              _createElementVNode("div", null, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.existingBenefits, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(["col-lg-auto col-md-auto col-sm-auto col-xs-12 pb-3", {'pe-0': !_ctx.isMobileScreen}])
                    }, [
                      _createVNode(_component_CoverAmountCard, {
                        value: item.coverAmount,
                        "onUpdate:value": ($event: any) => ((item.coverAmount) = $event),
                        title: item.benefit.benefitName,
                        content: [],
                        "monthly-cost": item.monthlyPremiumAmount ?? 0,
                        "min-cover": item.benefit.coverMinimumAmount,
                        "max-cover": item.benefit.coverMaximumAmount,
                        "saved-cover-amount": item.coverAmount,
                        "show-remove": false,
                        disabled: ""
                      }, null, 8, ["value", "onUpdate:value", "title", "monthly-cost", "min-cover", "max-cover", "saved-cover-amount"])
                    ], 2))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.insuranceCovers, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.benefitCode,
                      class: _normalizeClass(["col-lg-auto col-md-auto col-sm-auto col-xs-12 pb-3", {'pe-0': !_ctx.isMobileScreen}])
                    }, [
                      _createVNode(_component_CoverAmountCard, {
                        value: item.coverAmount,
                        "onUpdate:value": ($event: any) => ((item.coverAmount) = $event),
                        title: item.name,
                        content: item.content,
                        "monthly-cost": item.monthlyCost,
                        "min-cover": item.benefitPremium.coverMinimumAmount,
                        "max-cover": _ctx.getMaxCoverForSlider(item),
                        "saved-cover-amount": item.savedCoverAmount,
                        "show-remove": _ctx.canRemove(item.name),
                        "validation-error": _ctx.validationError.length > 0 && !(item.benefitCode == 'Life Cover'),
                        onUpdateValues: 
                  (newValue) => _ctx.reCalculateMonthlyCost(item, newValue)
              
                      }, null, 8, ["value", "onUpdate:value", "title", "content", "monthly-cost", "min-cover", "max-cover", "saved-cover-amount", "show-remove", "validation-error", "onUpdateValues"])
                    ], 2))
                  }), 128))
                ]),
                (_ctx.validationError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.validationError), 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.policyInfo.policy.policyType == '0')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createTextVNode(" Please click "),
                    _createElementVNode("button", {
                      class: "btn btn-link px-0 item-body pt-1",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToManualUnderwritingTab()))
                    }, " here "),
                    _createTextVNode(" if you want to refer the application for manual underwriting. ")
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_QuoteCard, {
                products: _ctx.insuranceCovers,
                "existing-products": _ctx.existingBenefits,
                "existing-premium": _ctx.existingPremiums,
                "is-mobile-screen": _ctx.isMobileScreen,
                "show-notes": _ctx.showQuoteCardNotes
              }, null, 8, ["products", "existing-products", "existing-premium", "is-mobile-screen", "show-notes"]),
              _hoisted_17,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productQuoteTexts, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("h6", null, _toDisplayString(item.title), 1),
                  _createElementVNode("p", {
                    class: "item-content",
                    innerHTML: item.content
                  }, null, 8, _hoisted_18)
                ]))
              }), 128)),
              _createElementVNode("hr", {
                class: _normalizeClass(["hr medium-bottom-spacing", { 'd-none': _ctx.isMobileScreen }])
              }, null, 2),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  (!_ctx.isMobileScreen)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass('btn btn-booster-secondary float-start'),
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showPopupBox && _ctx.showPopupBox(...args)))
                      }, " Cancel application "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("button", {
                    class: "btn btn-booster-primary float-end",
                    disabled: _ctx.isSubmitted,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitPolicyBenefit(_ctx.insuranceCovers)))
                  }, " Next ", 8, _hoisted_22)
                ]),
                (_ctx.isMobileScreen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("button", {
                        class: _normalizeClass('btn btn-link px-0 mb-4 item-body'),
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showPopupBox && _ctx.showPopupBox(...args)))
                      }, " Cancel application ")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
  ]))
}